import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  

  if (typeof window === 'undefined') {
    // On est côté serveur, ne pas bloquer, laisser Angular router faire le job plus tard côté client
    return true;
  }

  const token = window.localStorage.getItem('token');

  if (token) {
    return true;
  } else {
    router.navigate(['/landing-page']);
    return false;
  }

};
